export const CHATBOT_TOKEN_REQUESTING = 'trasactions/CHATBOT_TOKEN_REQUESTING';
export const CHATBOT_TOKEN_SUCCESS = 'trasactions/CHATBOT_TOKEN_SUCCESS';
export const CHATBOT_TOKEN_ERROR = 'trasactions/CHATBOT_TOKEN_ERROR';
